import React from 'react';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouLearn } from './components/WhatYouLearn';
import { ModulesSection } from './components/ModulesSection';
import { PremiumMaterialsSection } from './components/PremiumMaterialsSection';
import { PreviewSection } from './components/PreviewSection';
import { WorkplacesSection } from './components/WorkplacesSection';
import { TransformationSection } from './components/TransformationSection';
import { ProblemToolMap } from './components/ProblemToolMap';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-bg text-ink" data-id="element-0" data-mp="23ti6m04xmmi3">
      <HeroSection data-id="element-1" data-mp="3ij668fcdfvai" />
      <IdentificationSection data-id="element-2" data-mp="3ijpdn24eb1aa" />
      <ProductPresentation data-id="element-3" data-mp="3mlj6io8cn0zw" />
      <WhatYouLearn data-id="element-4" data-mp="3mkrgru1fnxhj" />
      <ModulesSection data-id="element-5" data-mp="3mjzs7369700r" />
      <PremiumMaterialsSection data-id="element-6" data-mp="3mjg8pi0yg3km" />
      <PreviewSection data-id="element-7" data-mp="3rbr9so7flver" />
      <WorkplacesSection data-id="element-8" data-mp="3rdar8i4tqci4" />
      <TransformationSection data-id="element-9" data-mp="3rd19tixuhdo1" />
      <ProblemToolMap data-id="element-10" data-mp="5yhupa6n3cr" />
      <OfferSection data-id="element-11" data-mp="67znpl2q47d" />
      <GuaranteeSection data-id="element-12" data-mp="4n5w26l2pak" />
      <FAQSection data-id="element-13" data-mp="82ld64660ci" />
      <FinalCTA data-id="element-14" data-mp="2zl3alhpbj03q" />
      <Footer data-id="element-15" data-mp="2zllff2q1qmn9" />
    </div>;
}